import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import TransactionSmallCard from "components/ui/Skeleton/TransactionSmallCard";
import { useClientContext } from "context/ClientContext";
import apiClient from "lib/api-client";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const fetchWipData = async (clientCode) => {
  const response = await apiClient.post("/api/v9/myBinnys/wipClient", {
    sortBy: "",
    sortOrder: "asc",
    searchBy: "",
    clientCode,
  });
  return response.data.data;
};

function WipPage() {
  const { setShowBagIcon, setBagCount, setDiaWeight, setGoldWeight } = useClientContext();
  const { clientId } = useParams();

  useEffect(() => {
    setShowBagIcon(true);

    return () => {
      setShowBagIcon(false);
    };
  }, []);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["wipData", clientId],
    queryFn: () => fetchWipData(clientId),
    retry: false,
  });

  useEffect(() => {
    setBagCount(data?.totalDepartmentGroupName?.TotalBQty || 0);
    setDiaWeight(data?.totalDepartmentGroupName?.TotalRequiredDWt || 0);
    setGoldWeight(data?.totalDepartmentGroupName?.TotalRequiredNWt || 0);

    return () => {
      setBagCount(0);
      setDiaWeight(0);
      setGoldWeight(0);
    };
  }, [data]);

  // if (isLoading) return <div>Loading...</div>;
  if (isLoading) {
    return <TransactionSmallCard count={5} />;
  }
  if (isError) return <div>No Data Available</div>;

  const cardData = data.departmentGroupName.map((item) => {
    const departmentName = Object.keys(item)[0];
    const departmentData = item[departmentName];

    return {
      name: departmentName,
      count: departmentData.BQty,
      icon: "RedBag",
      details: [
        { icon: "Small_Diamond", count: `${departmentData.RequiredDWt}Ct` },
        { icon: "GoldBar", count: `${departmentData.RequiredNWt}g` },
      ],
    };
  });

  return (
    <div>
      <Grid container spacing={2} marginTop={3} marginLeft={1} sx={{ display: "flex", gap: "2rem" }}>
        {cardData.length &&
          cardData.map((data) => {
            return (
              <Grid item sx={{ padding: "0px !important" }}>
                <ClientCard data={data} showLine={true} page="purchase" pageType={"wip"} />
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
}

export default WipPage;